<template>
  <div class="privacy">
    <header-top :headerPosition="false">
      <div slot="title">第三方共享个人信息清单</div>
    </header-top>
    <div class="privacy-wrapperOther">
      <div>
        <p class="dingdocnormal" style="line-height:22pt">
          <span style="font-size:12pt; -aw-import:spaces">&#xa0;&#xa0;&#xa0; </span
          ><span style="font-size:12pt"
            >为保障{{
            appName
          }}APP相关功能的实现与应用的稳定运行，我们会接入由第三方提供的软件开发包（SDK）、应用程序接口（API）以实现相关目的。我们会对授权合作伙伴获取有关信息的软件工具开发包（SDK）、应用程序接口（API）进行严格的安全检测，并与其约定严格的数据保护措施，令其按照我们的委托目的、服务说明以及其他任何相关的保密和安全措施来处理个人信息。您可以通过以下链接查看第三方的数据保护和使用规则。</span
          >
        </p>
        <h5 style="line-height:85%; font-size:12pt">
          <span style="font-family:宋体">一.内嵌SDK名单</span
          ><span style="width:16.99pt; font-family:宋体; display:inline-block">&#xa0;</span>
        </h5>
        <table class="tabOther" width="98%" border="1" cellspacing="0">
          <tr class="thead">
          <th class="tr1">第三方公司名称</th>
          <th class="tr2">产品/类型</th>
          <th class="tr3">共享信息名称</th>
          <th class="tr4">使用目的</th>
          <th class="tr5">使用场景</th>
          <th class="tr6">共享方式</th>
          <th class="tr7">第三方个人信息处理规则</th>
        </tr>
          <tr>
            <td
              style="width:78.95pt; border-top-style:solid; border-top-width:0.75pt; border-right-style:solid; border-right-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <span>北京小米移动软件有限公司</span>
              </p>
            </td>
            <td
              style="width:53.85pt; border-style:solid; border-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <span>小米推送SDK</span>
              </p>
            </td>
            <td
              style="width:104.05pt; border-style:solid; border-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <span
                  >设备标识（OAID、加密的Android
                  ID、IDFV）、应用信息（应用包名、版本号）、消息时间戳、消息内容、设备相关信息（设备厂商、设备型号、设备内存、操作系统版本、SDK版本、设备归属地（国家或地区））、运营商信息、网络类型、WiFi状态、通知栏状态</span
                >
              </p>
            </td>
            <td
              style="width:78.95pt; border-style:solid; border-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <span>消息推送</span>
              </p>
            </td>
            <td
              style="width:78.95pt; border-style:solid; border-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <span>小米消息推送</span>
              </p>
            </td>
            <td
              style="width:78.95pt; border-style:solid; border-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <span>SDK本机采集</span>
              </p>
            </td>
            <td
              style="width:79pt; border-top-style:solid; border-top-width:0.75pt; border-left-style:solid; border-left-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <a
                  href="https://dev.mi.com/console/doc/detail?pId=1822"
                  style="text-decoration:none"
                  ><span class="Hyperlink">https://dev.mi.com/console/doc/detail?pId=1822</span></a
                >
              </p>
            </td>
          </tr>
          <tr>
            <td
              style="width:78.95pt; border-top-style:solid; border-top-width:0.75pt; border-right-style:solid; border-right-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <span>华为软件技术有限公司</span>
              </p>
            </td>
            <td
              style="width:53.85pt; border-style:solid; border-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <span>华为推送SDK</span>
              </p>
            </td>
            <td
              style="width:104.05pt; border-style:solid; border-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <span
                  >应用基本信息（应用版本号/应用包名）、应用内设备标识符（AAID/PushToken）、设备的硬件信息、系统基本信息和系统设置信息、获取网络状态、访问网络</span
                >
              </p>
            </td>
            <td
              style="width:78.95pt; border-style:solid; border-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <span>消息推送</span>
              </p>
            </td>
            <td
              style="width:78.95pt; border-style:solid; border-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <span>华为消息推送</span>
              </p>
            </td>
            <td
              style="width:78.95pt; border-style:solid; border-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <span>SDK本机采集</span>
              </p>
            </td>
            <td
              style="width:79pt; border-top-style:solid; border-top-width:0.75pt; border-left-style:solid; border-left-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <a
                  href="https://developer.huawei.com/consumer/cn/doc/development/HMSCore-Guides/sdk-data-security-0000001050042177"
                  style="text-decoration:none"
                  ><span style="color:#000000"
                    >https://developer.huawei.com/consumer/cn/doc/development/HMSCore-Guides/sdk-data-security-0000001050042177</span
                  ></a
                >
              </p>
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <span style="-aw-import:ignore">&#xa0;</span>
              </p>
            </td>
          </tr>
          <tr>
            <td
              style="width:78.95pt; border-top-style:solid; border-top-width:0.75pt; border-right-style:solid; border-right-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <span>维沃移动通信有限公司</span>
              </p>
            </td>
            <td
              style="width:53.85pt; border-style:solid; border-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <span>Vivo推送 SDK</span>
              </p>
            </td>
            <td
              style="width:104.05pt; border-style:solid; border-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <span style="color:#333333"
                  >设备标识信息（如Android ID、GUID、GAID、OPENID、VAID、OAID、RegID、加密的Android
                  ID）、应用软件信息（如应用包名、版本号、APPID、安装</span
                ><span
                  >、卸载、恢复出厂设置、运行状态）、设备制造商、网络相关信息（IP地址、网络类型）</span
                ><span style="color:#333333"
                  >、国家码、设备类型、消息时间戳、消息内容、通知发送结果、SDK版本号、设备信息（设备型号、操作系统版本、通知栏状态、锁屏状态）</span
                >
              </p>
            </td>
            <td
              style="width:78.95pt; border-style:solid; border-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <span>消息推送</span>
              </p>
            </td>
            <td
              style="width:78.95pt; border-style:solid; border-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <span>Vivo推送SDK</span>
              </p>
            </td>
            <td
              style="width:78.95pt; border-style:solid; border-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <span>SDK本机采集</span>
              </p>
            </td>
            <td
              style="width:79pt; border-top-style:solid; border-top-width:0.75pt; border-left-style:solid; border-left-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <a
                  href="https://dev.vivo.com.cn/documentCenter/doc/652"
                  style="text-decoration:none"
                  ><span class="Hyperlink">https://dev.vivo.com.cn/documentCenter/doc/652</span></a
                >
              </p>
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <span style="-aw-import:ignore">&#xa0;</span>
              </p>
            </td>
          </tr>
          <tr>
            <td
              style="width:78.95pt; border-top-style:solid; border-top-width:0.75pt; border-right-style:solid; border-right-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <span>广东欢太科技有限公司</span>
              </p>
            </td>
            <td
              style="width:53.85pt; border-style:solid; border-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <span>oppo推送SDK</span>
              </p>
            </td>
            <td
              style="width:104.05pt; border-style:solid; border-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <span>设备标识（RegisterID、app</span>
              </p>
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <span>Key、appSecret</span
                ><ins
                  style=" -aw-revision-author:'gxp'; -aw-revision-datetime:'2024-08-06T11:28:00'"
                  ><span>、OAID</span></ins
                ><span>）、应用信息（MCS应用包名、应用版本号、推送SDK版本号）</span>
              </p>
            </td>
            <td
              style="width:78.95pt; border-style:solid; border-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <span>消息推送</span>
              </p>
            </td>
            <td
              style="width:78.95pt; border-style:solid; border-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <span>oppo消息推送</span>
              </p>
            </td>
            <td
              style="width:78.95pt; border-style:solid; border-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <span>SDK本机采集</span>
              </p>
            </td>
            <td
              style="width:79pt; border-top-style:solid; border-top-width:0.75pt; border-left-style:solid; border-left-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="font-size:11pt">
                <a
                  href="https://open.oppomobile.com/new/developmentDoc/info?id=11228"
                  style="text-decoration:none"
                  ><span class="Hyperlink"
                    >https://open.oppomobile.com/new/developmentDoc/info?id=11228</span
                  ></a
                >
              </p>
              <p class="dingdocnormal" style="font-size:11pt">
                <span style="-aw-import:ignore">&#xa0;</span>
              </p>
            </td>
          </tr>
          <tr>
            <td
              style="width:78.95pt; border-top-style:solid; border-top-width:0.75pt; border-right-style:solid; border-right-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <span>支付宝（中国）网络技术有限公司</span>
              </p>
            </td>
            <td
              style="width:53.85pt; border-style:solid; border-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <span>支付宝支付SDK</span>
              </p>
            </td>
            <td
              style="width:104.05pt; border-style:solid; border-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <span>设备标识（Android ID、OAID</span
                ><ins
                  style=" -aw-revision-author:'gxp'; -aw-revision-datetime:'2024-08-06T14:49:00'"
                  ><span>、IMEI、IMSI、</span></ins
                ><ins
                  style=" -aw-revision-author:'gxp'; -aw-revision-datetime:'2024-08-06T14:49:00'"
                  ><span>ICCID、MAC地址</span></ins
                ><ins
                  style=" -aw-revision-author:'gxp'; -aw-revision-datetime:'2024-08-06T14:50:00'"
                  ><span>、硬件序列号</span></ins
                ><span
                  >）、设备信息（系统设置、系统属性、设备型号、设备品牌、操作系统）、终端权限（读 SD
                  Card）、指定包名、网络信息（网络类型、wifi状态、wifi参数、wifi列表、运营商信息、BSSID、SSID）、IP地址</span
                ><ins
                  style=" -aw-revision-author:'gxp'; -aw-revision-datetime:'2024-08-06T14:50:00'"
                  ><span>、传感器信息</span></ins
                >
              </p>
            </td>
            <td
              style="width:78.95pt; border-style:solid; border-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <span>支付、提现</span>
              </p>
            </td>
            <td
              style="width:78.95pt; border-style:solid; border-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <span>使用支付宝支付或将收益提现到支付宝</span>
              </p>
            </td>
            <td
              style="width:78.95pt; border-style:solid; border-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <span>SDK本机采集</span>
              </p>
            </td>
            <td
              style="width:79pt; border-top-style:solid; border-top-width:0.75pt; border-left-style:solid; border-left-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <a href="https://opendocs.alipay.com/open/54/01g6qm" style="text-decoration:none"
                  ><span class="Hyperlink">https://opendocs.alipay.com/open/54/01g6qm</span></a
                >
              </p>
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <span style="-aw-import:ignore">&#xa0;</span>
              </p>
            </td>
          </tr>
          <tr>
            <td
              style="width:78.95pt; border-top-style:solid; border-top-width:0.75pt; border-right-style:solid; border-right-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <span>阿里云计算有限公司</span>
              </p>
            </td>
            <td
              style="width:53.85pt; border-style:solid; border-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <span
                  >阿里实名认证SDK（包含阿里百川电商（alibaba.one）SDK、淘宝安全组件、阿里聚安全安全组件（alibaba.wireless、SecurityBodySDK）和手淘h5框架）</span
                >
              </p>
            </td>
            <td
              style="width:104.05pt; border-style:solid; border-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <span
                  >设备标识信息（IDFA、IDFV、Android
                  ID、OAID、GAID、Mac地址、IMSI、IMEI、ICCID、MEID、设备序列号）、运营商信息、SIM卡状态、</span
                ><ins
                  style=" -aw-revision-author:'gxp'; -aw-revision-datetime:'2024-08-06T14:36:00'"
                  ><span>WiFi</span></ins
                ><ins
                  style=" -aw-revision-author:'gxp'; -aw-revision-datetime:'2024-08-06T14:36:00'"
                  ><span>状态、</span></ins
                ><span
                  >网络信息（BSSID、SSID、网络类型）、设备信息（设备制造商、设备品牌、设备类型及型号、设备名称、设备操作系统信息、设备内存及存储大小、电池及电量信息、基带信息、开机时间、屏幕亮度及分辨率、CPU信息）、传感器信息、位置信息（<b style="font-weight: bolder">非gps定位</b>）、运行列表、读写SD
                  card信息、IP地址、剪切板、</span
                ><ins
                  style=" -aw-revision-author:'gxp'; -aw-revision-datetime:'2024-08-06T14:37:00'"
                  ><span>读取指定包名、</span></ins
                ><ins
                  style=" -aw-revision-author:'gxp'; -aw-revision-datetime:'2024-08-06T14:38:00'"
                  ><span>相机、</span></ins
                ><span>宿主App应用信息（应用名称、应用版本、安装时间）</span>
              </p>
            </td>
            <td
              style="width:78.95pt; border-style:solid; border-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <span>实人认证相关组件、提现身份认证</span>
              </p>
            </td>
            <td
              style="width:78.95pt; border-style:solid; border-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <span>使用实人认证功能</span>
              </p>
            </td>
            <td
              style="width:78.95pt; border-style:solid; border-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <span>SDK本机采集</span>
              </p>
            </td>
            <td
              style="width:79pt; border-top-style:solid; border-top-width:0.75pt; border-left-style:solid; border-left-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="font-size:11pt">
                <a
                  href="https://terms.aliyun.com/legal-agreement/terms/suit_bu1_ali_cloud/suit_bu1_ali_cloud202107281509_18386.html?spm=a2c4g.11186623.0.0.464650f3vZi1mL"
                  style="text-decoration:none"
                  ><span class="Hyperlink"
                    >https://terms.aliyun.com/legal-agreement/terms/suit_bu1_ali_cloud/suit_bu1_ali_cloud202107281509_18386.html?spm=a2c4g.11186623.0.0.464650f3vZi1mL</span
                  ></a
                >
              </p>
              <p class="dingdocnormal" style="font-size:11pt">
                <span style="-aw-import:ignore">&#xa0;</span>
              </p>
            </td>
          </tr>
          <tr>
            <td
              style="width:78.95pt; border-top-style:solid; border-top-width:0.75pt; border-right-style:solid; border-right-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <span>Google LLC</span>
              </p>
            </td>
            <td
              style="width:53.85pt; border-style:solid; border-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <span>Zxing SDK</span>
              </p>
            </td>
            <td
              style="width:104.05pt; border-style:solid; border-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <span>光线传感器、终端权限（相机）</span>
              </p>
            </td>
            <td
              style="width:78.95pt; border-style:solid; border-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <span>生成二维码</span>
              </p>
            </td>
            <td
              style="width:78.95pt; border-style:solid; border-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <span>生成二维码</span>
              </p>
            </td>
            <td
              style="width:78.95pt; border-style:solid; border-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <span>SDK本机采集</span>
              </p>
            </td>
            <td
              style="width:79pt; border-top-style:solid; border-top-width:0.75pt; border-left-style:solid; border-left-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p style="text-align:center; font-size:11pt">
                <a href="https://github.com/zxing/zxing" style="text-decoration:none"
                  ><span class="Hyperlink">https://github.com/zxing/zxing</span></a
                >
              </p>
              <p style="text-align:center; font-size:11pt">
                <span style="-aw-import:ignore">&#xa0;</span>
              </p>
            </td>
          </tr>
          <tr>
            <td
              style="width:78.95pt; border-top-style:solid; border-top-width:0.75pt; border-right-style:solid; border-right-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <span>高德软件有限公司</span>
              </p>
            </td>
            <td
              style="width:53.85pt; border-style:solid; border-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <span>高德地图SDK</span>
              </p>
            </td>
            <td
              style="width:104.05pt; border-style:solid; border-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <span>位置信息</span
                ><span style="font-weight:bold">（经纬度、精确位置、粗略位置）</span><span>、</span
                ><span style="font-weight:bold"
                  >设备信息（IP地址、GNSS信息、WiFi状态、WiFi参数、WiFi列表、SSID、BSSID、基站信息、WiFi信号强度的信息、蓝牙信息</span
                ><span
                  >、传感器信息（矢量、加速度、压力、方向、地磁）、设备信号强度信息、读写外部存储目录</span
                ><ins
                  style=" -aw-revision-author:'gxp'; -aw-revision-datetime:'2024-08-06T14:25:00'"
                  ><span>、</span></ins
                ><ins
                  style=" -aw-revision-author:'gxp'; -aw-revision-datetime:'2024-08-06T14:26:00'"
                  ><span>硬件序列号</span></ins
                ><span>）、设备标识信息（IDFA、OAID</span
                ><ins
                  style=" -aw-revision-author:'gxp'; -aw-revision-datetime:'2024-08-06T14:18:00'"
                  ><span>、Android ID、MEID</span></ins
                ><span
                  >）、当前应用信息（应用名、应用版本号）、设备参数及系统信息（系统属性、设备型号、操作系统、运营商信息）</span
                ><ins
                  style=" -aw-revision-author:'gxp'; -aw-revision-datetime:'2024-08-06T14:24:00'"
                  ><span>、SIM状态</span></ins
                ><ins
                  style=" -aw-revision-author:'gxp'; -aw-revision-datetime:'2024-08-06T14:25:00'"
                  ><span>、读SD card、读指定包名</span></ins
                >
              </p>
            </td>
            <td
              style="width:78.95pt; border-style:solid; border-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <span>用于实现定位</span>
              </p>
            </td>
            <td
              style="width:78.95pt; border-style:solid; border-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <span>推荐附近用户、附近交友房间</span>
              </p>
            </td>
            <td
              style="width:78.95pt; border-style:solid; border-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <span>SDK本机采集</span>
              </p>
            </td>
            <td
              style="width:79pt; border-top-style:solid; border-top-width:0.75pt; border-left-style:solid; border-left-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <a href="https://lbs.amap.com/home/privacy" style="text-decoration:none"
                  ><span style="color:#000000">https://lbs.amap.com/home/privacy</span></a
                >
              </p>
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <span style="-aw-import:ignore">&#xa0;</span>
              </p>
            </td>
          </tr>

          <tr>
            <td
              style="width:78.95pt; border-top-style:solid; border-top-width:0.75pt; border-right-style:solid; border-right-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <span>北京百度网讯科技有限公司</span>
              </p>
            </td>
            <td
              style="width:53.85pt; border-style:solid; border-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <span>百度地图SDK</span>
              </p>
            </td>
            <td
              style="width:104.05pt; border-style:solid; border-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                设备信息（Android ID、IDFA、操作系统版本、设备配置、设备品牌及型号、应用名）、位置信息（<span style="font-weight: bold;">经纬度、GNSS、</span>WiFi网关地址、BSSID、SSID、WiFi信号强度、WiFi状态、WiFi参数、WiFi列表、基站ID数据信息、运营商信息、SIM卡状态、设备信号强度信息、IP地址、蓝牙信息、传感器信息（加速度、陀螺仪、方向、压力、旋转矢量、光照、磁力计））、读写SD caid、读取指定包名、网络信息（移动网络、WiFi网络）
              </p>
            </td>
            <td
              style="width:78.95pt; border-style:solid; border-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <span>用于实现定位</span>
              </p>
            </td>
            <td
              style="width:78.95pt; border-style:solid; border-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <span>推荐附近用户、附近交友房间</span>
              </p>
            </td>
            <td
              style="width:78.95pt; border-style:solid; border-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <span>SDK本机采集</span>
              </p>
            </td>
            <td
              style="width:79pt; border-top-style:solid; border-top-width:0.75pt; border-left-style:solid; border-left-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <a href="https://lbs.baidu.com/index.php?title=openprivacy" style="text-decoration:none"
                  ><span style="color:#000000">https://lbs.baidu.com/index.php?title=openprivacy</span></a
                >
              </p>
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <span style="-aw-import:ignore">&#xa0;</span>
              </p>
            </td>
          </tr>
          <tr>
            <td
              style="width:78.95pt; border-top-style:solid; border-top-width:0.75pt; border-right-style:solid; border-right-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <span>小沃科技有限公司</span>
              </p>
            </td>
            <td
              style="width:53.85pt; border-style:solid; border-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <span>联通SDK</span>
              </p>
            </td>
            <td
              style="width:104.05pt; border-style:solid; border-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <span
                  >网络类型、网络地址、运营商类型、本机手机号、手机设备类型、手机操作系统、硬件厂商</span
                >
              </p>
            </td>
            <td
              style="width:78.95pt; border-style:solid; border-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <span>一键登录</span>
              </p>
            </td>
            <td
              style="width:78.95pt; border-style:solid; border-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <span>联通一键登录</span>
              </p>
            </td>
            <td
              style="width:78.95pt; border-style:solid; border-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <span>SDK本机采集</span>
              </p>
            </td>
            <td
              style="width:79pt; border-top-style:solid; border-top-width:0.75pt; border-left-style:solid; border-left-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <a
                  href="https://opencloud.wostore.cn/authz/resource/html/disclaimer.html?fromsdk=true"
                  style="text-decoration:none"
                  ><span style="color:#000000"
                    >https://opencloud.wostore.cn/authz/resource/html/disclaimer.html?fromsdk=true</span
                  ></a
                >
              </p>
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <span style="-aw-import:ignore">&#xa0;</span>
              </p>
            </td>
          </tr>
          <tr>
            <td
              style="width:78.95pt; border-top-style:solid; border-top-width:0.75pt; border-right-style:solid; border-right-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <span>中移互联网有限公司</span>
              </p>
            </td>
            <td
              style="width:53.85pt; border-style:solid; border-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <span>移动SDK</span>
              </p>
            </td>
            <td
              style="width:104.05pt; border-style:solid; border-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <span>网络类型、网络地址（IP地址）、运营商类型、本机号码信息、SIM卡状态</span>
              </p>
            </td>
            <td
              style="width:78.95pt; border-style:solid; border-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <span>一键登录</span>
              </p>
            </td>
            <td
              style="width:78.95pt; border-style:solid; border-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <span>移动一键登录</span>
              </p>
            </td>
            <td
              style="width:78.95pt; border-style:solid; border-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <span>SDK本机采集</span>
              </p>
            </td>
            <td
              style="width:79pt; border-top-style:solid; border-top-width:0.75pt; border-left-style:solid; border-left-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <a
                  href="https://wap.cmpassport.com/resources/html/contract.html"
                  style="text-decoration:none"
                  ><span style="color:#000000"
                    >https://wap.cmpassport.com/resources/html/contract.html</span
                  ></a
                >
              </p>
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <span style="-aw-import:ignore">&#xa0;</span>
              </p>
            </td>
          </tr>
          <tr>
            <td
              style="width:78.95pt; border-top-style:solid; border-top-width:0.75pt; border-right-style:solid; border-right-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <ins
                  style=" -aw-revision-author:'gxp'; -aw-revision-datetime:'2024-08-20T12:12:00'"
                  ><span>天翼数字生活科技有限公司</span></ins
                ><del
                  style=" -aw-revision-author:'gxp'; -aw-revision-datetime:'2024-08-20T12:12:00'"
                  ><span>世纪龙信息网络有限责任公司</span></del
                >
              </p>
            </td>
            <td
              style="width:53.85pt; border-style:solid; border-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <ins
                  style=" -aw-revision-author:'gxp'; -aw-revision-datetime:'2024-08-20T12:13:00'"
                  ><span>天翼账号认证</span></ins
                ><del
                  style=" -aw-revision-author:'gxp'; -aw-revision-datetime:'2024-08-20T12:13:00'"
                  ><span>电信</span></del
                ><span>SDK</span>
              </p>
            </td>
            <td
              style="width:104.05pt; border-style:solid; border-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <span
                  >注册手机号码、本机号码、网络连接类型、网络状态信息、网络地址、运营商类型、手机设备类型、手机设备厂商、手机操作系统类型及版本</span
                >
              </p>
            </td>
            <td
              style="width:78.95pt; border-style:solid; border-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <span>一键登录</span>
              </p>
            </td>
            <td
              style="width:78.95pt; border-style:solid; border-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <span>电信一键登录</span>
              </p>
            </td>
            <td
              style="width:78.95pt; border-style:solid; border-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <span>SDK本机采集</span>
              </p>
            </td>
            <td
              style="width:79pt; border-top-style:solid; border-top-width:0.75pt; border-left-style:solid; border-left-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <a
                  href="https://e.189.cn/sdk/agreement/show.do?order=2&amp;type=main&amp;appKey=&amp;hidetop=true&amp;returnUrl="
                  style="text-decoration:none"
                  ><span style="color:#000000"
                    >https://e.189.cn/sdk/agreement/show.do?order=2&amp;type=main&amp;appKey=&amp;hidetop=true&amp;returnUrl=</span
                  ></a
                >
              </p>
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <span style="-aw-import:ignore">&#xa0;</span>
              </p>
            </td>
          </tr>
          <tr>
            <td
              style="width:78.95pt; border-top-style:solid; border-top-width:0.75pt; border-right-style:solid; border-right-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <span>上海兆言网络科技有限公司</span>
              </p>
            </td>
            <td
              style="width:53.85pt; border-style:solid; border-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <span>声网 SDK</span>
              </p>
            </td>
            <td
              style="width:104.05pt; border-style:solid; border-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                设备品牌、设备型号、操作系统版本、CPU信息、内存使用情况、电池电量信息、屏幕分辨率、IP地址、网络接入方式和类型、WIFI连接信息（SSID、BSSID）；频道内用户ID、传感器信息（仅设备的屏幕旋转方向）、终端权限（相机、麦克风、蓝牙连接权限（Android系统））、读SD card、电话状态
              </p>
            </td>
            <td
              style="width:78.95pt; border-style:solid; border-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <span>连麦</span>
              </p>
            </td>
            <td
              style="width:78.95pt; border-style:solid; border-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <span>音视频连麦</span>
              </p>
            </td>
            <td
              style="width:78.95pt; border-style:solid; border-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <span>SDK本机采集</span>
              </p>
            </td>
            <td
              style="width:79pt; border-top-style:solid; border-top-width:0.75pt; border-left-style:solid; border-left-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <a href="https://www.shengwang.cn/SDK-privacy-policy/" style="text-decoration:none"
                  ><span class="Hyperlink">https://www.shengwang.cn/SDK-privacy-policy/</span></a
                >
              </p>
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <span style="-aw-import:ignore">&#xa0;</span>
              </p>
            </td>
          </tr>
          <tr>
            <td
              style="width:78.95pt; border-top-style:solid; border-top-width:0.75pt; border-right-style:solid; border-right-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <span>电信终端产业协会</span>
              </p>
            </td>
            <td
              style="width:53.85pt; border-style:solid; border-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <span>OAID SDK</span>
              </p>
            </td>
            <td
              style="width:104.05pt; border-style:solid; border-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <span
                  >设备信息（设备制造商、设备型号、设备品牌）、运营商信息、应用包名信息、签名信息/APPID</span
                >
              </p>
              <p class="dingdocnormal" style="font-size:11pt">
                <span style="-aw-import:ignore">&#xa0;</span>
              </p>
            </td>
            <td
              style="width:78.95pt; border-style:solid; border-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <span>移动联盟广告标识符</span>
              </p>
            </td>
            <td
              style="width:78.95pt; border-style:solid; border-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <span>渠道投放</span>
              </p>
            </td>
            <td
              style="width:78.95pt; border-style:solid; border-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <span>SDK本机采集</span>
              </p>
            </td>
            <td
              style="width:79pt; border-top-style:solid; border-top-width:0.75pt; border-left-style:solid; border-left-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="font-size:11pt">
                <a href="https://www.msa-alliance.cn/col.jsp?id=122" style="text-decoration:none"
                  ><span class="Hyperlink">https://www.msa-alliance.cn/col.jsp?id=122</span></a
                >
              </p>
              <p class="dingdocnormal" style="font-size:11pt">
                <span style="-aw-import:ignore">&#xa0;</span>
              </p>
            </td>
          </tr>
          <tr>
            <td
              style="width:78.95pt; border-top-style:solid; border-top-width:0.75pt; border-right-style:solid; border-right-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <span>深圳市腾讯计算机系统有限公司</span>
              </p>
            </td>
            <td
              style="width:53.85pt; border-style:solid; border-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <span>腾讯云直播推流SDK</span>
              </p>
            </td>
            <td
              style="width:104.05pt; border-style:solid; border-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <span
                  >Wi-Fi 状态、系统属性、设备型号、操作系统、IP
                  地址、加速度传感器、终端权限（相机、麦克风、读写SDK配置文件和日志文件、蓝牙、电话状态）</span
                >
              </p>
            </td>
            <td
              style="width:78.95pt; border-style:solid; border-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <span>直播推拉流</span>
              </p>
            </td>
            <td
              style="width:78.95pt; border-style:solid; border-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <span>直播推拉流</span>
              </p>
            </td>
            <td
              style="width:78.95pt; border-style:solid; border-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <span>SDK本机采集</span>
              </p>
            </td>
            <td
              style="width:79pt; border-top-style:solid; border-top-width:0.75pt; border-left-style:solid; border-left-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <a
                  href="https://cloud.tencent.com/document/product/454/61839"
                  style="text-decoration:none"
                  ><span style="color:#000000"
                    >https://cloud.tencent.com/document/product/454/61839</span
                  ></a
                >
              </p>
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <span style="-aw-import:ignore">&#xa0;</span>
              </p>
            </td>
          </tr>
          <tr>
            <td
              style="width:78.95pt; border-top-style:solid; border-top-width:0.75pt; border-right-style:solid; border-right-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <span>深圳市腾讯计算机系统有限公司</span>
              </p>
            </td>
            <td
              style="width:53.85pt; border-style:solid; border-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <span>微信SDK</span>
              </p>
            </td>
            <td
              style="width:104.05pt; border-style:solid; border-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <span
                  >分享的图片或内容、支付订单信息、设备安装微信的状态、设备型号/剪切板（iOS系统）、SD卡数据、应用包名信息</span
                >
              </p>
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <span style="-aw-import:ignore">&#xa0;</span>
              </p>
            </td>
            <td
              style="width:78.95pt; border-style:solid; border-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <span>第三方登录、支付、分享</span>
              </p>
            </td>
            <td
              style="width:78.95pt; border-style:solid; border-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <span>使用微信登录、将内容分享至微信，或使用微信支付</span>
              </p>
            </td>
            <td
              style="width:78.95pt; border-style:solid; border-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <span>SDK本机采集</span>
              </p>
            </td>
            <td
              style="width:79pt; border-top-style:solid; border-top-width:0.75pt; border-left-style:solid; border-left-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <a
                  href="https://support.weixin.qq.com/cgi-bin/mmsupportacctnodeweb-bin/pages/RYiYJkLOrQwu0nb8"
                  style="text-decoration:none"
                  ><span class="Hyperlink"
                    >https://support.weixin.qq.com/cgi-bin/mmsupportacctnodeweb-bin/pages/RYiYJkLOrQwu0nb8</span
                  ></a
                >
              </p>
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <span style="-aw-import:ignore">&#xa0;</span>
              </p>
            </td>
          </tr>
          <tr>
            <td
              style="width:78.95pt; border-top-style:solid; border-top-width:0.75pt; border-right-style:solid; border-right-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <span>深圳市分秒网络科技有限公司</span>
              </p>
            </td>
            <td
              style="width:53.85pt; border-style:solid; border-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p style="font-size:11pt"><span>Openinstall SDK</span></p>
            </td>
            <td
              style="width:104.05pt; border-style:solid; border-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="font-size:11pt">
                <span
                  >Android
                  ID、设备序列号（SerialNumber）、设备品牌、设备型号、操作系统版本、IP地址、剪切板、读写SD
                  Card</span
                >
              </p>
            </td>
            <td
              style="width:78.95pt; border-style:solid; border-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <span>用于数据统计和分析</span>
              </p>
            </td>
            <td
              style="width:78.95pt; border-style:solid; border-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <span>统计分析</span>
              </p>
            </td>
            <td
              style="width:78.95pt; border-style:solid; border-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <span>SDK本机采集</span>
              </p>
            </td>
            <td
              style="width:79pt; border-top-style:solid; border-top-width:0.75pt; border-left-style:solid; border-left-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <a href="https://www.openinstall.io/privacy.html" style="text-decoration:none"
                  ><span class="Hyperlink">https://www.openinstall.io/privacy.html</span></a
                >
              </p>
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <span style="-aw-import:ignore">&#xa0;</span>
              </p>
            </td>
          </tr>
          <tr>
            <td
              style="width:78.95pt; border-top-style:solid; border-top-width:0.75pt; border-right-style:solid; border-right-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <span>北京壹六零二信息技术有限公司</span>
              </p>
            </td>
            <td
              style="width:53.85pt; border-style:solid; border-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <span>Rifle SDK</span>
              </p>
            </td>
            <td
              style="width:104.05pt; border-style:solid; border-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <span
                  >设备信息（设备系统信息、设备厂商信息、设备型号、设备标识符（IMEI、IDFA、IDFV、Android
                  ID、MEID、OAID、IMSI、硬件序列号）、Mac地址等信息）、设备网络信息（设备联网状态和类型等信息）、宿主App的进程信息、IP地址、运营商信息、终端权限（读取手机状态和身份）</span
                >
              </p>
            </td>
            <td
              style="width:78.95pt; border-style:solid; border-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <span>移动质量管理，崩溃记录和上报</span>
              </p>
            </td>
            <td
              style="width:78.95pt; border-style:solid; border-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <span>崩溃记录和上报</span>
              </p>
            </td>
            <td
              style="width:78.95pt; border-style:solid; border-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <span>SDK本机采集</span>
              </p>
            </td>
            <td
              style="width:79pt; border-top-style:solid; border-top-width:0.75pt; border-left-style:solid; border-left-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <a href="https://cosmos.immomo.com/" style="text-decoration:none"
                  ><span style="color:#000000">https://cosmos.immomo.com/home/copyright</span></a
                >
              </p>
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <span style="-aw-import:ignore">&#xa0;</span>
              </p>
            </td>
          </tr>
          <tr>
            <td
              style="width:78.95pt; border-top-style:solid; border-top-width:0.75pt; border-right-style:solid; border-right-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <span>北京壹六零二信息技术有限公司</span>
              </p>
            </td>
            <td
              style="width:53.85pt; border-style:solid; border-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <span>cosmos push SDK</span>
              </p>
            </td>
            <td
              style="width:104.05pt; border-style:solid; border-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <span
                  >设备信息（设备系统信息、设备厂商信息、设备型号、设备标识符（IMEI、IDFA、IDFV、Android
                  ID、MEID、OAID、IMSI、硬件序列号）、Mac地址等信息）、设备网络信息（设备联网状态和类型</span
                ><ins
                  style=" -aw-revision-author:'gxp'; -aw-revision-datetime:'2024-08-06T11:25:00'"
                  ><span>、SSID、BSSID</span></ins
                ><span
                  >等信息）、宿主App的进程信息、IP地址、运营商信息、终端权限（读取手机状态和身份</span
                ><ins
                  style=" -aw-revision-author:'gxp'; -aw-revision-datetime:'2024-08-06T11:26:00'"
                  ><span>、读写SD card</span></ins
                ><span>）</span>
              </p>
            </td>
            <td
              style="width:78.95pt; border-style:solid; border-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <span>为用户提供Push通知</span>
              </p>
            </td>
            <td
              style="width:78.95pt; border-style:solid; border-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <span>消息推送</span>
              </p>
            </td>
            <td
              style="width:78.95pt; border-style:solid; border-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <span>SDK本机采集</span>
              </p>
            </td>
            <td
              style="width:79pt; border-top-style:solid; border-top-width:0.75pt; border-left-style:solid; border-left-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <a href="https://cosmos.immomo.com/home/copyright" style="text-decoration:none"
                  ><span style="color:#000000">https://cosmos.immomo.com/home/copyright</span></a
                >
              </p>
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <span style="-aw-import:ignore">&#xa0;</span>
              </p>
            </td>
          </tr>
          <tr>
            <td
            style="width:78.95pt; border-style:solid; border-width:0.75pt; vertical-align:top; background-color:#ffffff;font-size:11pt">北京陌陌科技有限公司</td>
            <td
            style="width:78.95pt; border-style:solid; border-width:0.75pt; vertical-align:top; background-color:#ffffff;font-size:11pt">陌陌SDK（陌陌resdownloder、陌陌medialog、陌陌cvcenter）</td>
            <td
            style="width:78.95pt; border-style:solid; border-width:0.75pt; vertical-align:top; background-color:#ffffff;font-size:11pt">Android ID、BSSID、MAC地址、SSID、OAID、传感器参数、定位信息、读写SDCard、读取WiFi参数、读取运行列表、读取指定包名、运营商信息、本机IP、SIM卡状态、IMEI、MEID、拍照、录音</td>
            <td
            style="width:78.95pt; border-style:solid; border-width:0.75pt; vertical-align:top; background-color:#ffffff;font-size:11pt">提供音视频通话服务</td>
            <td
            style="width:78.95pt; border-style:solid; border-width:0.75pt; vertical-align:top; background-color:#ffffff;font-size:11pt">音视频通话</td>
            <td
            style="width:78.95pt; border-style:solid; border-width:0.75pt; vertical-align:top; background-color:#ffffff;font-size:11pt">SDK本机采集</td>
            <td
            style="width:78.95pt; border-style:solid; border-width:0.75pt; vertical-align:top; background-color:#ffffff;font-size:11pt"><a href="https://m.immomo.com/inc/privacy_policy.html">https://m.immomo.com/inc/privacy_policy.html</a></td>
          </tr>
          <tr>
            <td
              style="width:78.95pt; border-top-style:solid; border-top-width:0.75pt; border-right-style:solid; border-right-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <ins
                  style=" -aw-revision-author:'gxp'; -aw-revision-datetime:'2024-08-20T11:51:00'"
                  ><span>深圳市腾讯计算机系统有限公司</span></ins
                >
              </p>
            </td>
            <td
              style="width:53.85pt; border-style:solid; border-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <ins
                  style=" -aw-revision-author:'gxp'; -aw-revision-datetime:'2024-08-20T11:51:00'"
                  ><span>腾讯</span></ins
                ><ins
                  style=" -aw-revision-author:'gxp'; -aw-revision-datetime:'2024-08-20T11:51:00'"
                  ><span>Bugly</span></ins
                ><ins
                  style=" -aw-revision-author:'gxp'; -aw-revision-datetime:'2024-08-20T11:51:00'"
                  ><span style="-aw-import:spaces">&#xa0;</span><span>SDK</span></ins
                >
              </p>
            </td>
            <td
              style="width:104.05pt; border-style:solid; border-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <ins
                  style=" -aw-revision-author:'gxp'; -aw-revision-datetime:'2024-08-20T11:51:00'"
                  ><span>设备</span></ins
                ><ins
                  style=" -aw-revision-author:'gxp'; -aw-revision-datetime:'2024-08-20T11:51:00'"
                  ><span>标识符</span></ins
                ><ins
                  style=" -aw-revision-author:'gxp'; -aw-revision-datetime:'2024-08-20T11:51:00'"
                  ><span>(IMEI/MAC</span></ins
                ><ins
                  style=" -aw-revision-author:'gxp'; -aw-revision-datetime:'2024-08-20T11:51:00'"
                  ><span style="text-decoration:underline">地址</span></ins
                ><ins
                  style=" -aw-revision-author:'gxp'; -aw-revision-datetime:'2024-08-20T11:51:00'"
                  ><span>/Android ID/SIM卡IMSI/IP</span></ins
                ><ins
                  style=" -aw-revision-author:'gxp'; -aw-revision-datetime:'2024-08-20T11:51:00'"
                  ><span>/IDFV</span></ins
                ><ins
                  style=" -aw-revision-author:'gxp'; -aw-revision-datetime:'2024-08-20T11:51:00'"
                  ><span>)</span></ins
                ><ins
                  style=" -aw-revision-author:'gxp'; -aw-revision-datetime:'2024-08-20T11:51:00'"
                  ><span>、设备信息（手机品牌、</span></ins
                ><ins
                  style=" -aw-revision-author:'gxp'; -aw-revision-datetime:'2024-08-20T11:51:00'"
                  ><span
                    >型号、系统版本信息、磁盘信息、内存信息、硬件序列号）g、读取和写入SD
                    Card信息、网络信息、运行进程信息及PID</span
                  ></ins
                >
              </p>
            </td>
            <td
              style="width:78.95pt; border-style:solid; border-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p style="font-size:11pt">
                <ins
                  style=" -aw-revision-author:'gxp'; -aw-revision-datetime:'2024-08-20T11:51:00'"
                  ><span>崩溃上报</span></ins
                >
              </p>
            </td>
            <td
              style="width:78.95pt; border-style:solid; border-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <ins
                  style=" -aw-revision-author:'gxp'; -aw-revision-datetime:'2024-08-20T11:51:00'"
                  ><span>崩溃上报</span></ins
                >
              </p>
            </td>
            <td
              style="width:78.95pt; border-style:solid; border-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <ins
                  style=" -aw-revision-author:'gxp'; -aw-revision-datetime:'2024-08-20T11:51:00'"
                  ><span>SDK本机采集</span></ins
                >
              </p>
            </td>
            <td
              style="width:79pt; border-top-style:solid; border-top-width:0.75pt; border-left-style:solid; border-left-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <a
                  href="https://privacy.qq.com/document/preview/fc748b3d96224fdb825ea79e132c1a56"
                  style="text-decoration:none"
                  ><ins
                    style=" -aw-revision-author:'gxp'; -aw-revision-datetime:'2024-08-20T11:51:00'"
                    ><span class="Hyperlink" style=""
                      >https://privacy.qq.com/document/preview/fc748b3d96224fdb</span
                    ></ins
                  ><ins
                    style=" -aw-revision-author:'gxp'; -aw-revision-datetime:'2024-08-20T11:51:00'"
                    ><span class="Hyperlink" style="">825ea79e132c1a56</span></ins
                  ></a
                >
              </p>
              <p class="dingdocnormal" style="text-align:center">
                <span style="font-family:等线; -aw-import:ignore">&#xa0;</span>
              </p>
            </td>
          </tr>
          <tr>
            <td
              style="width:78.95pt; border-top-style:solid; border-top-width:0.75pt; border-right-style:solid; border-right-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt"><span>——</span></p>
            </td>
            <td
              style="width:53.85pt; border-style:solid; border-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <span>com.liulishuo.filedownloader</span>
              </p>
            </td>
            <td
              style="width:104.05pt; border-style:solid; border-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <span>宿主App的进程信息</span>
              </p>
            </td>
            <td
              style="width:78.95pt; border-style:solid; border-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p style="font-size:11pt"><span>Android 文件下载引擎</span></p>
            </td>
            <td
              style="width:78.95pt; border-style:solid; border-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <span>下载资源文件</span>
              </p>
            </td>
            <td
              style="width:78.95pt; border-style:solid; border-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <span>SDK本机采集</span>
              </p>
            </td>
            <td
              style="width:79pt; border-top-style:solid; border-top-width:0.75pt; border-left-style:solid; border-left-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <a
                  href="https://github.com/lingochamp/FileDownloader/blob/master/README-zh.md"
                  target="_blank"
                  style="text-decoration:none"
                  ><span style="color:#000000"
                    >https://github.com/lingochamp/FileDownloader/blob/master/README-zh.md</span
                  ></a
                >
              </p>
            </td>
          </tr>
          <tr>
            <td
              style="width:78.95pt; border-top-style:solid; border-top-width:0.75pt; border-right-style:solid; border-right-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt"><span>——</span></p>
            </td>
            <td
              style="width:53.85pt; border-style:solid; border-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <span>MklibrarySDK</span>
              </p>
            </td>
            <td
              style="width:104.05pt; border-style:solid; border-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <span>SD card信息</span>
              </p>
            </td>
            <td
              style="width:78.95pt; border-style:solid; border-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <span>webview封装</span>
              </p>
            </td>
            <td
              style="width:78.95pt; border-style:solid; border-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <span>网页浏览</span>
              </p>
            </td>
            <td
              style="width:78.95pt; border-style:solid; border-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <span>SDK本机采集</span>
              </p>
            </td>
            <td
              style="width:79pt; border-top-style:solid; border-top-width:0.75pt; border-left-style:solid; border-left-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <a href="https://cosmos.immomo.com/home/copyright" style="text-decoration:none"
                  ><span style="color:#000000">https://cosmos.immomo.com/home/copyright</span></a
                >
              </p>
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <span style="-aw-import:ignore">&#xa0;</span>
              </p>
            </td>
          </tr>
          <tr>
            <td
              style="width:78.95pt; border-top-style:solid; border-top-width:0.75pt; border-right-style:solid; border-right-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <span>BumpTech</span>
              </p>
            </td>
            <td
              style="width:53.85pt; border-style:solid; border-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <span>BumptechGlide</span>
              </p>
            </td>
            <td
              style="width:104.05pt; border-style:solid; border-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <span>终端权限（读SDCard）</span>
              </p>
            </td>
            <td
              style="width:78.95pt; border-style:solid; border-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <span>图片加载框架</span>
              </p>
            </td>
            <td
              style="width:78.95pt; border-style:solid; border-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <span>图片加载</span>
              </p>
            </td>
            <td
              style="width:78.95pt; border-style:solid; border-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <span>SDK本机采集</span>
              </p>
            </td>
            <td
              style="width:79pt; border-top-style:solid; border-top-width:0.75pt; border-left-style:solid; border-left-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <a href="https://bumptech.github.io/glide/" style="text-decoration:none"
                  ><span class="Hyperlink">https://bumptech.github.io/glide/</span></a
                >
              </p>
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <span style="-aw-import:ignore">&#xa0;</span>
              </p>
            </td>
          </tr>
          <tr>
            <td
              style="width:78.95pt; border-top-style:solid; border-top-width:0.75pt; border-right-style:solid; border-right-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt"><span>——</span></p>
            </td>
            <td
              style="width:53.85pt; border-style:solid; border-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <span>MediaRecorder</span>
              </p>
            </td>
            <td
              style="width:104.05pt; border-style:solid; border-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <span
                  >设备信息（设备系统信息、设备厂商信息、设备型号、设备标识符等信息）、设备网络信息（设备联网状态和类型等信息）</span
                >
              </p>
            </td>
            <td
              style="width:78.95pt; border-style:solid; border-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <span>提供拍照、录像服务</span>
              </p>
            </td>
            <td
              style="width:78.95pt; border-style:solid; border-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <span>拍照、录像</span>
              </p>
            </td>
            <td
              style="width:78.95pt; border-style:solid; border-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <span>SDK本机采集</span>
              </p>
            </td>
            <td
              style="width:79pt; border-top-style:solid; border-top-width:0.75pt; border-left-style:solid; border-left-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <a href="https://cosmos.immomo.com/home/copyright" style="text-decoration:none"
                  ><span style="color:#000000">https://cosmos.immomo.com/home/copyright</span></a
                >
              </p>
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <span style="-aw-import:ignore">&#xa0;</span>
              </p>
            </td>
          </tr>
          <tr>
            <td
              style="width:78.95pt; border-top-style:solid; border-top-width:0.75pt; border-right-style:solid; border-right-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt"><span>——</span></p>
            </td>
            <td
              style="width:53.85pt; border-style:solid; border-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <span>光子IM</span>
              </p>
            </td>
            <td
              style="width:104.05pt; border-style:solid; border-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <span
                  >设备信息（设备系统信息、设备厂商信息、设备型号、设备标识符等信息）、设备网络信息（设备联网状态和类型等信息）</span
                >
              </p>
            </td>
            <td
              style="width:78.95pt; border-style:solid; border-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <span>即时聊天</span>
              </p>
            </td>
            <td
              style="width:78.95pt; border-style:solid; border-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <span>即时聊天</span>
              </p>
            </td>
            <td
              style="width:78.95pt; border-style:solid; border-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <span>SDK本机采集</span>
              </p>
            </td>
            <td
              style="width:79pt; border-top-style:solid; border-top-width:0.75pt; border-left-style:solid; border-left-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <a href="https://cosmos.immomo.com/home/copyright" style="text-decoration:none"
                  ><span style="color:#000000">https://cosmos.immomo.com/home/copyright</span></a
                >
              </p>
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <span style="-aw-import:ignore">&#xa0;</span>
              </p>
            </td>
          </tr>
          <tr>
            <td
              style="width:78.95pt; border-top-style:solid; border-top-width:0.75pt; border-right-style:solid; border-right-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt"><span>-</span></p>
            </td>
            <td
              style="width:53.85pt; border-style:solid; border-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <span>OkHttp（包括okio、okhttp3.io）</span>
              </p>
            </td>
            <td
              style="width:104.05pt; border-style:solid; border-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <span>读SD Card、IP地址</span>
              </p>
            </td>
            <td
              style="width:78.95pt; border-style:solid; border-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <span style="color:#343434">OkHttp底层库</span>
              </p>
            </td>
            <td
              style="width:78.95pt; border-style:solid; border-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <span style="color:#343434">处理http请求、访问网页、下载网页文件</span>
              </p>
            </td>
            <td
              style="width:78.95pt; border-style:solid; border-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <span>SDK本机采集</span>
              </p>
            </td>
            <td
              style="width:79pt; border-top-style:solid; border-top-width:0.75pt; border-left-style:solid; border-left-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <a href="https://square.github.io/okhttp/" style="text-decoration:none"
                  ><span class="Hyperlink">https://square.github.io/okhttp/</span></a
                >
              </p>
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <span style="-aw-import:ignore">&#xa0;</span>
              </p>
            </td>
          </tr>
          <tr>
            <td
              style="width:78.95pt; border-top-style:solid; border-top-width:0.75pt; border-right-style:solid; border-right-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <ins
                  style=" -aw-revision-author:'gxp'; -aw-revision-datetime:'2024-08-06T11:12:00'"
                  ><span>-</span></ins
                >
              </p>
            </td>
            <td
              style="width:53.85pt; border-style:solid; border-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <ins
                  style=" -aw-revision-author:'gxp'; -aw-revision-datetime:'2024-08-06T11:12:00'"
                  ><span>B</span></ins
                ><ins
                  style=" -aw-revision-author:'gxp'; -aw-revision-datetime:'2024-08-06T11:12:00'"
                  ><span>ase</span></ins
                ><ins
                  style=" -aw-revision-author:'gxp'; -aw-revision-datetime:'2024-08-06T14:10:00'"
                  ><span>V</span></ins
                ><ins
                  style=" -aw-revision-author:'gxp'; -aw-revision-datetime:'2024-08-06T11:12:00'"
                  ><span>erify</span></ins
                >
              </p>
            </td>
            <td
              style="width:104.05pt; border-style:solid; border-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <ins
                  style=" -aw-revision-author:'gxp'; -aw-revision-datetime:'2024-08-06T11:13:00'"
                  ><span>相机</span></ins
                >
              </p>
            </td>
            <td
              style="width:78.95pt; border-style:solid; border-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <ins
                  style=" -aw-revision-author:'gxp'; -aw-revision-datetime:'2024-08-06T11:18:00'"
                  ><span>数据</span></ins
                ><ins
                  style=" -aw-revision-author:'gxp'; -aw-revision-datetime:'2024-08-06T11:14:00'"
                  ><span>验证服务</span></ins
                >
              </p>
            </td>
            <td
              style="width:78.95pt; border-style:solid; border-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <ins
                  style=" -aw-revision-author:'gxp'; -aw-revision-datetime:'2024-08-06T11:19:00'"
                  ><span>数据验证</span></ins
                >
              </p>
            </td>
            <td
              style="width:78.95pt; border-style:solid; border-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <ins
                  style=" -aw-revision-author:'gxp'; -aw-revision-datetime:'2024-08-06T11:14:00'"
                  ><span>SDK本机采集</span></ins
                >
              </p>
            </td>
            <td
              style="width:79pt; border-top-style:solid; border-top-width:0.75pt; border-left-style:solid; border-left-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <a href="https://github.com/baseverify/bv-sdk-js" style="text-decoration:none"
                  ><ins
                  style=" -aw-revision-author:'gxp'; -aw-revision-datetime:'2024-08-06T11:13:00'"
                  ><span>https://github.com/baseverify/bv-sdk-js</span></ins
                ></a>
              </p>
            </td>
          </tr>
          <tr>
            <td
              style="width:78.95pt; border-top-style:solid; border-top-width:0.75pt; border-right-style:solid; border-right-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <ins
                  style=" -aw-revision-author:'gxp'; -aw-revision-datetime:'2024-08-06T14:28:00'"
                  ><span>-</span></ins
                >
              </p>
            </td>
            <td
              style="width:53.85pt; border-style:solid; border-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <ins
                  style=" -aw-revision-author:'gxp'; -aw-revision-datetime:'2024-08-06T14:28:00'"
                  ><span>com.meituan</span></ins
                ><ins
                  style=" -aw-revision-author:'gxp'; -aw-revision-datetime:'2024-08-06T14:28:00'"
                  ><span>.robust</span></ins
                >
              </p>
            </td>
            <td
              style="width:104.05pt; border-style:solid; border-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <ins
                  style=" -aw-revision-author:'gxp'; -aw-revision-datetime:'2024-08-06T14:28:00'"
                  ><span>读写SD card</span></ins
                >
              </p>
            </td>
            <td
              style="width:78.95pt; border-style:solid; border-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <ins
                  style=" -aw-revision-author:'gxp'; -aw-revision-datetime:'2024-08-06T14:29:00'"
                  ><span>热修复框架</span></ins
                >
              </p>
            </td>
            <td
              style="width:78.95pt; border-style:solid; border-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <ins
                  style=" -aw-revision-author:'gxp'; -aw-revision-datetime:'2024-08-06T14:29:00'"
                  ><span>热修复</span></ins
                >
              </p>
            </td>
            <td
              style="width:78.95pt; border-style:solid; border-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <ins
                  style=" -aw-revision-author:'gxp'; -aw-revision-datetime:'2024-08-06T14:29:00'"
                  ><span>SDK本机采集</span></ins
                >
              </p>
            </td>
            <td
              style="width:79pt; border-top-style:solid; border-top-width:0.75pt; border-left-style:solid; border-left-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <a href="https://github.com/Meituan-Dianping/Robust" style="text-decoration:none"
                  ><ins
                    style=" -aw-revision-author:'gxp'; -aw-revision-datetime:'2024-08-06T14:29:00'"
                    ><span class="Hyperlink" style=""
                      >https://github.com/Meituan-Dianping/Robust</span
                    ></ins
                  ></a
                >
              </p>
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <span style="-aw-import:ignore">&#xa0;</span>
              </p>
            </td>
          </tr>
          <tr>
            <td
              style="width:78.95pt; border-top-style:solid; border-top-width:0.75pt; border-right-style:solid; border-right-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <ins
                  style=" -aw-revision-author:'gxp'; -aw-revision-datetime:'2024-08-06T11:29:00'"
                  ><span>-</span></ins
                >
              </p>
            </td>
            <td
              style="width:53.85pt; border-top-style:solid; border-top-width:0.75pt; border-right-style:solid; border-right-width:0.75pt; border-left-style:solid; border-left-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <ins
                  style=" -aw-revision-author:'gxp'; -aw-revision-datetime:'2024-08-06T11:29:00'"
                  ><span>RxJavaFX</span></ins
                >
              </p>
            </td>
            <td
              style="width:104.05pt; border-top-style:solid; border-top-width:0.75pt; border-right-style:solid; border-right-width:0.75pt; border-left-style:solid; border-left-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <ins
                  style=" -aw-revision-author:'gxp'; -aw-revision-datetime:'2024-08-06T11:29:00'"
                  ><span>读SD card</span></ins
                >
              </p>
            </td>
            <td
              style="width:78.95pt; border-top-style:solid; border-top-width:0.75pt; border-right-style:solid; border-right-width:0.75pt; border-left-style:solid; border-left-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <ins
                  style=" -aw-revision-author:'gxp'; -aw-revision-datetime:'2024-08-06T12:02:00'"
                  ><span>JavaFX库</span></ins
                >
              </p>
            </td>
            <td
              style="width:78.95pt; border-top-style:solid; border-top-width:0.75pt; border-right-style:solid; border-right-width:0.75pt; border-left-style:solid; border-left-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <ins
                  style=" -aw-revision-author:'gxp'; -aw-revision-datetime:'2024-08-06T12:02:00'"
                  ><span>JavaFX 事件</span></ins
                ><ins
                  style=" -aw-revision-author:'gxp'; -aw-revision-datetime:'2024-08-06T12:03:00'"
                  ><span>转换</span></ins
                >
              </p>
            </td>
            <td
              style="width:78.95pt; border-top-style:solid; border-top-width:0.75pt; border-right-style:solid; border-right-width:0.75pt; border-left-style:solid; border-left-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <ins
                  style=" -aw-revision-author:'gxp'; -aw-revision-datetime:'2024-08-06T12:04:00'"
                  ><span>SDK本机采集</span></ins
                >
              </p>
            </td>
            <td
              style="width:79pt; border-top-style:solid; border-top-width:0.75pt; border-left-style:solid; border-left-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <a href="https://github.com/ReactiveX/RxJavaFX" style="text-decoration:none"
                  ><ins
                    style=" -aw-revision-author:'gxp'; -aw-revision-datetime:'2024-08-06T12:04:00'"
                    ><span class="Hyperlink" style=""
                      >https://github.com/ReactiveX/RxJavaFX</span
                    ></ins
                  ></a
                >
              </p>
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <span style="-aw-import:ignore">&#xa0;</span>
              </p>
            </td>
          </tr>

          <tr>
            <td
              style="width:78.95pt; border-top-style:solid; border-top-width:0.75pt; border-right-style:solid; border-right-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <ins
                  style=" -aw-revision-author:'gxp'; -aw-revision-datetime:'2024-08-06T11:29:00'"
                  ><span>-</span></ins
                >
              </p>
            </td>
            <td
              style="width:53.85pt; border-top-style:solid; border-top-width:0.75pt; border-right-style:solid; border-right-width:0.75pt; border-left-style:solid; border-left-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <ins
                  style=" -aw-revision-author:'gxp'; -aw-revision-datetime:'2024-08-06T11:29:00'"
                  ><span>VideoProcessor</span></ins
                >
              </p>
            </td>
            <td
              style="width:104.05pt; border-top-style:solid; border-top-width:0.75pt; border-right-style:solid; border-right-width:0.75pt; border-left-style:solid; border-left-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <ins
                  style=" -aw-revision-author:'gxp'; -aw-revision-datetime:'2024-08-06T11:29:00'"
                  ><span>存储权限</span></ins
                >
              </p>
            </td>
            <td
              style="width:78.95pt; border-top-style:solid; border-top-width:0.75pt; border-right-style:solid; border-right-width:0.75pt; border-left-style:solid; border-left-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <ins
                  style=" -aw-revision-author:'gxp'; -aw-revision-datetime:'2024-08-06T12:02:00'"
                  ><span>压缩视频</span></ins
                >
              </p>
            </td>
            <td
              style="width:78.95pt; border-top-style:solid; border-top-width:0.75pt; border-right-style:solid; border-right-width:0.75pt; border-left-style:solid; border-left-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <ins
                  style=" -aw-revision-author:'gxp'; -aw-revision-datetime:'2024-08-06T12:02:00'"
                  ><span>用户上传视频时</span></ins
                >
              </p>
            </td>
            <td
              style="width:78.95pt; border-top-style:solid; border-top-width:0.75pt; border-right-style:solid; border-right-width:0.75pt; border-left-style:solid; border-left-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <ins
                  style=" -aw-revision-author:'gxp'; -aw-revision-datetime:'2024-08-06T12:04:00'"
                  ><span>SDK本机采集</span></ins
                >
              </p>
            </td>
            <td
              style="width:79pt; border-top-style:solid; border-top-width:0.75pt; border-left-style:solid; border-left-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <a href="https://github.com/yellowcath/VideoProcessor" style="text-decoration:none"
                  ><ins
                    style=" -aw-revision-author:'gxp'; -aw-revision-datetime:'2024-08-06T12:04:00'"
                    ><span class="Hyperlink" style=""
                      >https://github.com/yellowcath/VideoProcessor</span
                    ></ins
                  ></a
                >
              </p>
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <span style="-aw-import:ignore">&#xa0;</span>
              </p>
            </td>
          </tr>
        </table>

        <h5 style="line-height:85%; font-size:12pt">
          <span style="font-family:宋体">二.关联APP名单</span>
        </h5>
        <table
          cellspacing="0"
          cellpadding="0"
          class="TableGrid"
          style="border:0.75pt solid #000000; -aw-border-insideh:0.75pt single #000000; -aw-border-insidev:0.75pt single #000000; border-collapse:collapse"
        >
          <tr>
            <td
              style="width:58.5pt; border-right-style:solid; border-right-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <span style="font-weight:bold">第三方公司名称</span>
              </p>
            </td>
            <td
              style="width:58.5pt; border-right-style:solid; border-right-width:0.75pt; border-left-style:solid; border-left-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <span style="font-weight:bold">产品/类型</span>
              </p>
            </td>
            <td
              style="width:58.5pt; border-right-style:solid; border-right-width:0.75pt; border-left-style:solid; border-left-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <span style="font-weight:bold">共享信息名称</span>
              </p>
            </td>
            <td
              style="width:58.5pt; border-right-style:solid; border-right-width:0.75pt; border-left-style:solid; border-left-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <span style="font-weight:bold">使用目的</span>
              </p>
            </td>
            <td
              style="width:58.5pt; border-right-style:solid; border-right-width:0.75pt; border-left-style:solid; border-left-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <span style="font-weight:bold">使用场景</span>
              </p>
            </td>
            <td
              style="width:58.5pt; border-right-style:solid; border-right-width:0.75pt; border-left-style:solid; border-left-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <span style="font-weight:bold">共享方式</span>
              </p>
            </td>
            <td
              style="width:58.5pt; border-left-style:solid; border-left-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <span style="font-weight:bold">第三方个人信息处理规则</span>
              </p>
            </td>
          </tr>
          <tr>
            <td
              colspan="7"
              style="width:414pt; border-top-style:solid; border-top-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <span style="font-weight:bold">无</span>
              </p>
            </td>
          </tr>
        </table>

        <h5 style="line-height:85%; font-size:12pt;margin-top: 20px">
          <span style="font-family:宋体"
            >三.合作商第三方名单（广告投放、内容审核之类的，可能是通过后台推送数据的）</span
          >
        </h5>
        <table
          cellspacing="0"
          cellpadding="0"
          class="TableGrid"
          style="border:0.75pt solid #000000; -aw-border-insideh:0.75pt single #000000; -aw-border-insidev:0.75pt single #000000; border-collapse:collapse"
        >
          <tr>
            <td
              style="width:58.5pt; border-right-style:solid; border-right-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <span style="font-weight:bold">第三方公司名称</span>
              </p>
            </td>
            <td
              style="width:58.5pt; border-right-style:solid; border-right-width:0.75pt; border-left-style:solid; border-left-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <span style="font-weight:bold">产品/类型</span>
              </p>
            </td>
            <td
              style="width:58.5pt; border-right-style:solid; border-right-width:0.75pt; border-left-style:solid; border-left-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <span style="font-weight:bold">共享信息名称</span>
              </p>
            </td>
            <td
              style="width:58.5pt; border-right-style:solid; border-right-width:0.75pt; border-left-style:solid; border-left-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <span style="font-weight:bold">使用目的</span>
              </p>
            </td>
            <td
              style="width:58.5pt; border-right-style:solid; border-right-width:0.75pt; border-left-style:solid; border-left-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <span style="font-weight:bold">使用场景</span>
              </p>
            </td>
            <td
              style="width:58.5pt; border-right-style:solid; border-right-width:0.75pt; border-left-style:solid; border-left-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <span style="font-weight:bold">共享方式</span>
              </p>
            </td>
            <td
              style="width:58.5pt; border-left-style:solid; border-left-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <span style="font-weight:bold">第三方个人信息处理规则</span>
              </p>
            </td>
          </tr>
          <tr style="height:28.5pt">
            <td
              colspan="7"
              style="width:414pt; border-top-style:solid; border-top-width:0.75pt; vertical-align:top; background-color:#ffffff"
            >
              <p class="dingdocnormal" style="text-align:center; font-size:11pt">
                <span style="font-weight:bold">无</span>
              </p>
            </td>
          </tr>
        </table>

        <p class="dingdocnormal" style="font-size:12pt">
          <span style="font-weight:bold; -aw-import:spaces">&#xa0;</span>
        </p>
        <h5 style="line-height:85%; font-size:12pt">
          <span style="font-family:宋体; -aw-import:spaces">&#xa0;</span>
        </h5>
      </div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
del {
  display: none;
}
ins {
  text-decoration: none;
}
.tabOther {
  margin: 0 auto;
  margin-bottom: 20px;
  line-height: 30px;
  color: #9a9eb9;
  text-align: center;
  border-color: #eee;
  table-layout: fixed;
  word-break: break-all;
  tr {
    font-size: 16px;
    .tr7 {
      word-break: break-all;
    }
  }
}
.thead {
  color: #3f446f;
  font-size: 24px;
  line-height: 30px;
  margin-top: 7px;
  text-align: center;
}
.privacy {
  background-color: #f6f5fb;
  padding-bottom: 130px;
}
.privacy-wrapperOther {
  padding-top: 120px;
  padding: 120px 10px 0;
  width: 730px;
  text-align: left;
}
.privacy-title {
  margin-bottom: 40px;
  font-family: "PingFangSC-Medium";
  font-size: 30px;
  color: rgb(63, 68, 111);
}
.privacy-date {
  margin-left: 300px;
  margin-bottom: 4px;
  text-align: right;
  font-size: 26px;
  width: 390px;
  color: #3f446f;
}
.privacy-date-second {
  margin-bottom: 20px;
}
.privacy-content {
  font-size: 26px;
  color: #3f446f;
  line-height: 41px;
  padding-bottom: 40px;
}
</style>
<script>
import HeaderTop from "src/components/HeaderTop.vue";

export default {
  name: "Privacy",
  data() {
    return {
      appName: this.$store.state.appName
    };
  },
  mounted() {
    console.log("appName:", this.appName);
  },
  components: {
    "header-top": HeaderTop // 顶部导航组件
  }
};
</script>
